import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ExpenseService } from '../stores/expense/expense.service';

@Pipe({
    name: 'expenseTypeName',
    pure: true,
})
export class ExpenseTypeNamePipe implements PipeTransform {
    constructor(
        private expenseService: ExpenseService,
        private translate: TranslateService,
    ) {}

    transform(
        codeOrId: string | number,
        defaultName: string | null = null,
    ): Observable<string> {
        if (!codeOrId) {
            return of('');
        }

        return this.expenseService.GetExpenseTypes().pipe(
            map((response) => {
                // Find the expense type by code
                const expenseType = response.Result.find(
                    (et) => et.Code === codeOrId || et.Id === codeOrId,
                );

                if (!expenseType) {
                    if (defaultName) {
                        return defaultName;
                    }
                    // Fallback to translation if type not found
                    return this.translate.instant(
                        'db.expense-types.' + codeOrId,
                    );
                }

                // Return the Name which is already computed by the service
                // (either CustomName or translated name)
                return expenseType.Name;
            }),
        );
    }
}
